import * as React from 'react';
import { cn } from '@/lib/utils';

const QuestionSidebarChart = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-question-sidebar-chart', 'mb-4', 'flex items-center', className)}
    {...props}
  >
    {children}
  </div>
));
QuestionSidebarChart.displayName = 'QuestionSidebarChart';

const QuestionSidebarChartContainer = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-question-sidebar-chart-container',
      // Estilos aninhados para Highcharts (seletor de classes externo)
      '[&_.highcharts-container]:!w-20', // 80px
      '[&_.highcharts-container]:!h-20', // 80px
      '[&_.highcharts-root]:!w-20',
      '[&_.highcharts-root]:!h-20',
      'flex-shrink-0', // Evita que encolha
      className
    )}
    {...props}
  >
    {children}
  </div>
));
QuestionSidebarChartContainer.displayName = 'QuestionSidebarChartContainer';

const QuestionSidebarLegends = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-question-sidebar-legends', 'flex-grow', className)}
    {...props}
  >
    {children}
  </div>
));
QuestionSidebarLegends.displayName = 'QuestionSidebarLegends';

const QuestionSidebarLegend = React.forwardRef(({ className, children, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-question-sidebar-legend', 'text-neutral-darker', 'mb-0', className)}
    {...props}
  >
    {children}
  </p>
));
QuestionSidebarLegend.displayName = 'QuestionSidebarLegend';

export { QuestionSidebarChart, QuestionSidebarChartContainer, QuestionSidebarLegends, QuestionSidebarLegend };
